module.exports = __webpack_public_path__ + "img/services.aa973738.png";